import {
  CheckEmail,
  ConfirmLogin,
  EnableTwoFactor,
  InvalidEmail,
  Login,
  ResetPassword,
  UserDetails,
  VerifyEmail,
} from 'app/components/Authentication';
import { AuthenticationStep } from 'app/components/Authentication/types';

import useStep from 'app/hooks/useStep';

function Authentication() {
  const steps: AuthenticationStep[] = [
    'checkEmail',
    'verifyEmail',
    'userDetails',
    'enableTwoFactor',
    'login',
    'confirmLogin',
    'invalidEmail',
    'resetPassword',
  ];

  const { currentStep, setStep } = useStep(steps.length);

  const handleSetStep = (stepToGo: AuthenticationStep) =>
    setStep(steps.findIndex((step) => step === stepToGo));

  switch (steps[currentStep]) {
    case 'verifyEmail':
      return <VerifyEmail onSetStep={handleSetStep} />;
    case 'userDetails':
      return <UserDetails onSetStep={handleSetStep} />;
    case 'enableTwoFactor':
      return <EnableTwoFactor onSetStep={handleSetStep} />;
    case 'login':
      return <Login onSetStep={handleSetStep} />;
    case 'confirmLogin':
      return <ConfirmLogin onSetStep={handleSetStep} />;
    case 'invalidEmail':
      return <InvalidEmail onSetStep={handleSetStep} />;
    case 'resetPassword':
      return <ResetPassword onSetStep={handleSetStep} />;
    case 'checkEmail':
    default:
      return <CheckEmail onSetStep={handleSetStep} />;
  }
}

export default Authentication;
